import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-seq-filter-status",
  "use": "icon-seq-filter-status-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" fill=\"none\" id=\"icon-seq-filter-status\">\n  <path d=\"M10.0001 8.33464V15.0013M10.0001 5.0013V6.66797M1.66675 3.3263C1.66675 2.4113 2.41508 1.66797 3.32508 1.66797H16.6751C17.5901 1.66797 18.3334 2.4163 18.3334 3.3263V16.6763C18.3334 17.5921 17.5851 18.3346 16.6751 18.3346H3.32508C2.8856 18.3335 2.46444 18.1585 2.15368 17.8477C1.84292 17.5369 1.66785 17.1158 1.66675 16.6763V3.3263Z\" stroke=\"#373C42\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol